import React from 'react';
import { Button, Popconfirm, PopconfirmProps, ButtonProps } from 'antd';

export interface IConfirmButtonProps extends ButtonProps {
  showConfirm?: boolean;
  confirmProps?: Omit<PopconfirmProps, 'children'>;
}

const ConfirmButton: React.FC<IConfirmButtonProps> = ({
  showConfirm = false,
  confirmProps = { title: null },
  onClick,
  ...buttonProps
}) => {
  if (!confirmProps.onConfirm && showConfirm) {
    confirmProps.onConfirm = (e) => onClick?.(e as any);
  }

  const button = (
    <Button {...buttonProps} onClick={!showConfirm ? onClick : undefined}>
      {buttonProps.children}
    </Button>
  );

  if (showConfirm) {
    return <Popconfirm {...confirmProps}>{button}</Popconfirm>;
  }

  return button;
};

export default ConfirmButton;
